const OPEN_CLASS = "open";

// A widget is usually more than one element — a panel and the overlay behind
// it — and they have to move together.
export function open(...elements) {
  for (const element of elements) {
    element.classList.add(OPEN_CLASS);
  }
}

export function close(...elements) {
  for (const element of elements) {
    element.classList.remove(OPEN_CLASS);
  }
}

export function onEscape(element, handler) {
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && element.classList.contains(OPEN_CLASS)) {
      handler(event);
    }
  });
}
